import React from 'react';
import NumberFormat from 'react-number-format';

const WalletCreditDisplay = ({ credit, suffix = ' تومان', className }) => {
  const toman = (parseFloat(credit) || 0) / 10;

  if (toman === 0) {
    return (
      <span className={className}>
        <NumberFormat value={0} displayType='text' thousandSeparator suffix={suffix} />
      </span>
    );
  }

  const isCreditor = toman > 0;
  const color = isCreditor ? '#28a745' : '#dc3545';

  return (
    <span className={className} style={{ color, fontWeight: 600, display: 'block', textAlign: 'end', width: '100%' }}>
      <NumberFormat value={Math.abs(toman)} displayType='text' thousandSeparator suffix={suffix} /> ({isCreditor ? 'بستانکار' : 'بدهکار'})
    </span>
  );
};

export default WalletCreditDisplay;
